import React from 'react';
import { Grid, Heading, VStack } from '@chakra-ui/react';
import { ReactComponent as Logo } from 'assets/logo.svg';

const About: React.FC = () => {
  return (
    <Grid minH="100vh" justifyContent="center" alignItems="center" p={[8, 12]}>
      <VStack d="block" w={['full', 450]} spacing={8}>
        <Logo />
        <Heading as="h1" pt={[0, 8]} size="xl" textAlign="center">
          About Page
        </Heading>
      </VStack>
    </Grid>
  );
};

export default About;
